var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonograph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V4C11 3.45 10.55 3 10 3H6C5.45 3 5 3.45 5 4V5C4.45 5 4 5.45 4 6V7C4 7.55 4.45 8 5 8V12C5 12.55 5.45 13 6 13H10C10.55 13 11 12.55 11 12V8C11.55 8 12 7.55 12 7V6C12 5.45 11.55 5 11 5ZM9 11H7V8H9V11Z",
    fill: "#212D41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 1,
    stroke: "#212D41",
    strokeWidth: 2,
    fill: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonograph);
export default __webpack_public_path__ + "static/media/monograph.df01678945a896ae8629f222eadfa8aa.svg";
export { ForwardRef as ReactComponent };